import http from '@/common/http'

export function stationCodeList(params = {}) {
  return http.post('/cms/station/qrcode/list', params)
}
